// ADMIN and MANAGER are both manager-level (matches the backend's
// _is_manager). Shared by every roll-forward entry point and
// AdminSettingsPage so the three gates can't drift from one another.
export const canManage = (u) => ["MANAGER", "ADMIN"].includes(String(u?.role).toUpperCase());
